module.exports = __webpack_public_path__ + "img/icon_no_search_content.13e66eac.png";